import AppRoutes from "./AppRoutes";
import LoginRoutes from "./LoginRoutes";
import DashBoardRoutes from "./DashboardRoutes";
import JobTemplate001 from "../views/app/landingpagetemplate/jobtemplate/jobtemplate001";
import JobTemplate002 from "../views/app/landingpagetemplate/jobtemplate/jobtemplate002";
import { useEffect } from "react";
import { Stringutility } from "../utilities/stringutility";
import { StorageService } from "../services/StorageService";
import { StorageValues } from "../constants/storageValues";

const JobReqRoutes = () => {
  let count = 0;
  const query = new URLSearchParams(window.location.search);
  var jobId = Stringutility.getValue(query.get("jobId")).trim();
  var flavor = Stringutility.getValue(query.get("flavor")).trim();
  var templateName = Stringutility.getValue(query.get("templateName")).trim();
  var user = StorageService.getFromLocalStorage(StorageValues.USER);

  useEffect(() => {
  }, [count]);

  return (
    <div>
      {(() => {
        if (!Stringutility.isNullOrEmpty(jobId)) {
          if (user !== null) {
            if (
              Stringutility.getValue(
                StorageService.getFromSessionStorage(StorageValues.APPLY_JOB)
              ) == "clickapplybutton"
            ) {
              if (
                StorageService.getFromLocalStorage(
                  StorageValues.PROFILE == "completed"
                )
              ) {
                return <DashBoardRoutes />;
              } else {
                return <AppRoutes />;
              }
            } else {
              if (templateName=='') {
                return <JobTemplate001 jobId={jobId} flavor={flavor} />;
              } else if (templateName === "jobtemplate001") {
                return <JobTemplate001 jobId={jobId} flavor={flavor} />;
              } else if (templateName === "jobtemplate002") {
                return <JobTemplate002 jobId={jobId} flavor={flavor} />;
              } else {
                return <JobTemplate001 jobId={jobId} flavor={flavor} />;
              }
            }
          } else {
            if (templateName=='') {
              return <JobTemplate001 jobId={jobId} flavor={flavor} />;
            } else if (templateName === "jobtemplate001") {
              return <JobTemplate001 jobId={jobId} flavor={flavor} />;
            } else if (templateName === "jobtemplate002") {
              return <JobTemplate002 jobId={jobId} flavor={flavor} />;
            } else {
              return <JobTemplate001 jobId={jobId} flavor={flavor} />;
            }
          }
        } else {
          return <LoginRoutes />;
        }
      })()}
    </div>
  );
};
export default JobReqRoutes;
